/**
 * The header's way to the assistant while its floating launcher is hidden (tablet pass
 * 2026-10-20, item 1; assistantLauncher.js): on a module's routes and below 1,202 px of shell,
 * the mobile layout included (round 2, P2: at 768 the only opener was inside More, so on
 * /dashboard none showed). Nothing while the launcher shows, so there is only ever one opener.
 * A 44 px target (round 2, P5; it was 40); tokens only.
 *
 * Polish 4: from RAIL_DEFAULT_BELOW (1,202 px of viewport) up it carries a visible "Assistant"
 * label beside the icon (icon-only, it took a minute to find on the real tablet); below that it
 * stays a 44 px icon, where the header is crowded. The accessible name and tooltip are the same
 * at every width.
 */
import { useState } from 'react';
import { Sparkles } from 'lucide-react';
import { openAssistant, useAssistantLauncherHidden } from './assistantLauncher';
import { RAIL_DEFAULT_BELOW } from '../../utils/sidebarLayout';
import useViewportWidth from '../layout/tools/useViewportWidth';

export default function AssistantHeaderButton() {
  const hidden = useAssistantLauncherHidden();
  const [hover, setHover] = useState(false);
  const labelled = useViewportWidth() >= RAIL_DEFAULT_BELOW;
  if (!hidden) return null;
  return (
    <button
      type="button"
      onClick={openAssistant}
      title="Assistant"
      aria-label="Assistant"
      onMouseEnter={() => setHover(true)}
      onMouseLeave={() => setHover(false)}
      style={{
        ...(labelled
          ? { minWidth: '44px', height: '44px', padding: '0 12px 0 10px', gap: '6px' }
          : { width: '44px', height: '44px' }),
        borderRadius: '8px',
        border: 'none',
        background: hover ? 'var(--bg-tertiary)' : 'transparent',
        color: 'var(--text-secondary)',
        cursor: 'pointer',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        transition: 'background 0.2s ease'
      }}
    >
      <Sparkles size={18} aria-hidden="true" />
      {labelled && <span style={{ fontSize: '14px', fontWeight: 500, whiteSpace: 'nowrap' }}>Assistant</span>}
    </button>
  );
}
